<template>
  <div class="loading-view-root">
    <div class="loader-container">
      <div class="dotted-loader"></div>
      <div class="waiting-text">Waiting For Response(s)</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading-view-root {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  background: transparent !important;
  background-color: transparent !important;
}

.dotted-loader {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dotted-loader::after,
.dotted-loader::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  border-color: rgba(21, 195, 154, 1) transparent rgba(21, 195, 154, 1) transparent;
}

.dotted-loader::before {
  width: 60px;
  height: 60px;
  animation: turn-right 1.5s linear infinite;
}

.dotted-loader::after {
  width: 40px;
  height: 40px;
  animation: turn-left 1.5s linear infinite;
}

.waiting-text {
  margin-top: 18px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

@keyframes turn-right {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes turn-left {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
